import './ButtonTabMapping.scss';
import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import HotelsConfig from './HotelsConfig/HotelsConfig';
import RoomConfig from './RoomConfig/RoomConfig';
import RegimesConfig from './RegimesConfig/RegimesConfig';
import ServicesConfig from './ServicesConfig/ServicesConfig';
import GeneralConfig from './GeneralConfig/GeneralConfig';
import LoadingDataComponent from '../../../../common/LoadingData/LoadingDataComponent';
import { useAppConfig } from '../../../../../Contexts/AppConfigContext';
import { getAllCountries, getWSUsers } from '../../../../../api/repositoryEP';
import { WSUsers } from '../../../../../models/ConfigurationData';

interface ButtonTabMappingProps {
    language: string;
}

const ButtonTabMapping = (props: ButtonTabMappingProps): JSX.Element => {
    const { t } = useTranslation();
    const [selectedIndex, setSelectedIndex] = useState<number>(0); // Estado para el índice seleccionado
    const appConfig = useAppConfig();
    const [wsUsers, setWsUsers] = useState<WSUsers[]>([]);
    const [wsDataLoading, setWsDataLoading] = useState<boolean>(true);

    const [countries, setCountries] = useState<{ key: string; value: string }[]>([]);


    useEffect(() => {
        setWsDataLoading(true);

        Promise.all([getAllCountries()])
            .then(([countriesResponse]) => {
                if (countriesResponse && countriesResponse?.type == 1 && countriesResponse.data) {
                    setCountries(countriesResponse.data);
                }

                if (countriesResponse && countriesResponse?.type == 1 && countriesResponse.data) {
                    setCountries(countriesResponse.data);
                }
            })
            .finally(() => {
                setWsDataLoading(false);
            });
    }, []);

    const items: Array<any> = [
        {
            label: t("components.tab-mapping.room-config.title"),
            component: <RoomConfig language={props.language} />,
        },
        {
            label: t("components.tab-mapping.regimes-config.title"),
            component: <RegimesConfig language={props.language} />,
        },
        {
            label: t("components.tab-mapping.hotels-config.title"),
            component: <HotelsConfig language={props.language} />,
        },
        {
            label: t("components.tab-mapping.services-config.title"),
            component: <ServicesConfig language={props.language} />,
        },
        {
            label: t("components.tab-mapping.general-config.title"),
            component: <GeneralConfig  countries={countries} language={props.language} />,
        }
    ];


    const generalTabIndex = items.length - 1;

    const handleButtonClick = (index: number) => {
        if (index === generalTabIndex && wsDataLoading) {
            return;
        }

        setSelectedIndex(index);
    };




    return (
        <div className='button-tab-mapping-component'>
            <div className="button-group">
                {items.map((item, index) => (
                    <Button
                        // className="app-button"
                        key={index}
                        className={`app-button ${index === selectedIndex ? 'is-active' : ''}`}
                        disabled={index === generalTabIndex && wsDataLoading}
                        onClick={() => handleButtonClick(index)}
                    >
                        {item.label}
                    </Button>
                ))}
            </div>
            <div className="component-container">
                {selectedIndex === generalTabIndex && wsDataLoading
                    ? <LoadingDataComponent />
                    : items[selectedIndex]?.component}
            </div>
        </div>
    );
}

export default ButtonTabMapping;
